import { useMutation } from '@tanstack/react-query';
import { createTagsWithIds } from 'shared/services/backend-api';
import { NewTagWithID } from 'shared/types/tag';

export const useCreateTagsWithIdsMutation = () =>
  useMutation({
    mutationFn: async (goals: NewTagWithID[]) => createTagsWithIds(goals),
  });
